import { PrivacyPolicyTemplate } from "@templates/privacy-policy";
import { GetServerSideProps, NextPage } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";

const PrivacyPolicy: NextPage = () => {
  const { t } = useTranslation("privacy-policy");

  return (
    <>
      <Head>
        <title>{t("title")} - FeelingHome</title>
      </Head>
      <PrivacyPolicyTemplate />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  defaultLocale,
  locale,
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "en", [
        "common",
        "privacy-policy",
      ])),
    },
  };
};

export default PrivacyPolicy;
